import React from 'react'
import { View } from 'react-native'
import { createStackNavigator } from '@react-navigation/stack'
import { HeaderBackButton } from '@react-navigation/elements'

import { useContent } from '@sart/content'
import { theme, colors, backgroundColors } from '@sart/styles'
import { CompanyIcon } from '@sart/icons'
import { Text } from '@sart/components'

import { stackNavigationProps } from '../nagivationProps'

import Dashboard from './DashboardContainer'
import Minutes from './Minutes'
import Data from './Data'
import Texts from './Texts'
import PostpaidMinutes from './PostpaidMinutes'
import PostpaidData from './PostpaidData'
import PostpaidTexts from './PostpaidTexts'
import ViewCashBarcode from './ViewCashBarcode'
import ConfirmCancel from '../ConfirmCancel'
import Confirmation from '../Confirmation'
import BroadbandData from './BroadbandData'
import HomePhoneMinutes from './HomePhoneMinutes'
import MenuStackNavigator from '../Menu'
import ActivateICCID from './ActivateICCID'

const Stack = createStackNavigator()

function DashboardStackNavigator() {

  const content = useContent()

  return (
    <Stack.Navigator
      initialRouteName='Overview'
      screenOptions={{
        ...stackNavigationProps.screenOptions,
        // headerShown:false,
        tabBarVisible: false,
        gestureEnabled: true,
      }}
    >
      <Stack.Screen
        name="Overview"
        component={Dashboard}
        options={{
          gestureEnabled: false,
          headerShown: false,
          title: "",
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0,
          },
          headerLeft: () => (<View style={{ paddingLeft: 15 }}>
            <CompanyIcon color={colors.srGreen} height={60} width={60} />
          </View>
          ),
        }}
      />
      <Stack.Screen
        name="Minutes"
        component={Minutes}
        options={({ navigation }) => ({
          title: content.navigation.minutes,
          headerCenter: () => <Text style={theme.navigationHeader}>{content.navigation.minutes}</Text>,
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.menu}
              onPress={() => {
                navigation.goBack()
              }}
              tintColor={colors.brightOrange}
            />
          ),
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0,
            backgroundColor: colors.darkCharcoal
          },
        })}
      />
      <Stack.Screen
        name="Data"
        component={Data}
        options={({ navigation }) => ({
          title: content.navigation.data,
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.menu}
              onPress={() => {
                navigation.goBack()
              }}
              tintColor={colors.brightOrange}
            />
          ),
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0,
            backgroundColor: colors.darkCharcoal
          },
        })}
      />
      <Stack.Screen
        name="Texts"
        component={Texts}
        options={({ navigation }) => ({
          title: content.navigation.texts,
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.menu}
              onPress={() => {
                navigation.goBack()
              }}
              tintColor={colors.brightOrange}
            />
          ),
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0,
            backgroundColor: colors.darkCharcoal
          },
        })}
      />
      <Stack.Screen
        name="PostpaidMinutes"
        component={PostpaidMinutes}
        options={{
          title: content.navigation.minutes,
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
        }}
      />
      <Stack.Screen
        name="PostpaidData"
        component={PostpaidData}
        options={{
          title: content.navigation.data,
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.menu}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Dashboard')
              }}
              tintColor={colors.brightOrange}
            />
          ),
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
        }}
      />
      <Stack.Screen
        name="PostpaidTexts"
        component={PostpaidTexts}
        options={{
          title: content.navigation.texts,
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
        }}
      />
      <Stack.Screen
        name="BroadbandData"
        component={BroadbandData}
        options={{
          title: content.navigation.data,
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
        }}
      />
      <Stack.Screen
        name="HomePhoneMinutes"
        component={HomePhoneMinutes}
        options={{
          title: content.navigation.minutes,
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            borderBottomWidth: 0,
            elevation: 0
          },
        }}
      />
      <Stack.Screen
        name="Confirmation"
        component={Confirmation}
        options={({ navigation }) => ({
          title: '',
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.dashboard}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Dashboard')
              }}
              tintColor={colors.srGreen}
            />
          ),
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            backgroundColor: colors.darkCharcoal,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View />)
        })}
      />
      <Stack.Screen
        name="ConfirmCancel"
        component={ConfirmCancel}
        options={({ navigation }) => ({
          title: '',
          headerShown: false,
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.dashboard}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Dashboard')
              }}
              tintColor={colors.clear}
            />
          ),
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            backgroundColor: colors.srGreen,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View />)
        })}
      />
      <Stack.Screen
        name="ViewCashBarcode"
        component={ViewCashBarcode}
        options={({ navigation }) => ({
          title: content.navigation.confirmation,
          headerShown: false,
          headerTitleStyle: theme.navigationHeaderPlan,
          headerStyle: {
            backgroundColor: backgroundColors.white,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: (<View />),
          headerCenter: () => <Text style={theme.navigationHeaderPlan}>{content.navigation.confirmation}</Text>,
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.dashboard}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Dashboard')
              }}
              tintColor={colors.srGreen}
            />
          )
        })}
      />
      <Stack.Screen
        name="ActivateICCID"
        component={ActivateICCID}
        options={({ navigation }) => ({
          title: content.navigation.confirmation,
          headerShown: false,
          headerTitleStyle: theme.navigationHeaderPlan,
          headerStyle: {
            backgroundColor: backgroundColors.white,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: (<View />),
          headerCenter: () => <Text style={theme.navigationHeaderPlan}>{content.navigation.confirmation}</Text>,
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.dashboard}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Dashboard')
              }}
              tintColor={colors.brightOrange}
            />
          )
        })}
      />
    </Stack.Navigator>
  )
}

export default DashboardStackNavigator
